/** Agent Layer product copy — Agent 0 (personal) + Agent 1 (API keys). */

export const AGENT_0 = {
	id: "0" as const,
	title: "Agent 0",
	short: "Personal agent",
	job: "Your Internet Identity registered on agent_gateway. Browser liquidate and vault actions use this principal.",
};

export const AGENT_1 = {
	id: "1" as const,
	title: "Agent 1",
	short: "API keys",
	job: "Revocable keys on the same account for bots and skills. Secret shown once; stored as a hash on the gateway.",
};

export const AGENT_FLEET_BLURB =
	"One personal agent on your Internet Identity. API keys on that account power external bots. Privileged calls cost cycles (credits or waivers).";

export const AGENT_KEY_SECURITY =
	"Keys are linked to your registered agent. The secret is shown only when created, stored as a hash on the gateway (not re-readable, not vetKeys), and revocable anytime. Deactivate your agent to kill privileged bot calls without revoking keys.";

export const AGENT_ACTIVE_HELP =
	"When inactive, agent_gateway blocks privileged ops (API liquidate, vault write, new keys). Human liquidate on /liquidate still uses the protocol directly.";

export const AGENT_FEE_SUSTAINABILITY =
	"Privileged II calls: attached message cycles first, then daily waivers, then prepaid credits. Max 3 in-flight gateway ops per agent; scans are free queries. For 24/7 volume, fund credits + USDM and run an A API key outside the browser.";

/** Hunt / Autopilot info popup body (dynamic cap + spent). */
export function agentHuntHelpText(opts: {
	dailyCapUsdm: number;
	spentTodayUsdm: number;
}): string {
	return [
		AGENT_ACTIVE_HELP,
		`Autopilot uses gateway liquidate (waivers/credits) + USDM escrow; partial repay only; daily cap ${opts.dailyCapUsdm.toLocaleString()} USDM (spent today ${opts.spentTodayUsdm.toFixed(0)}). Close tab / logout stops F. For 24/7 use an A API key + Minimac.`,
	].join(" ");
}

export const HUNT_SETTINGS_UPDATED_KEY =
	"motokomaker.v2.huntSettingsUpdatedAt";

export function loadHuntSettingsUpdatedAt(): number | null {
	try {
		const v = Number(localStorage.getItem(HUNT_SETTINGS_UPDATED_KEY));
		return Number.isFinite(v) && v > 0 ? v : null;
	} catch {
		return null;
	}
}

export function saveHuntSettingsUpdatedAt(ts = Date.now()) {
	try {
		localStorage.setItem(HUNT_SETTINGS_UPDATED_KEY, String(ts));
	} catch {
		/* ignore */
	}
}
